module.exports = __webpack_public_path__ + "static/media/audioVideoEquipment.cb4ca1a0.svg";